import React from 'react';
import './App.scss'
import './scss/PublicCards.scss'
import './scss/custom.scss'
import './AppGlobal.scss'
import 'font-awesome/css/font-awesome.min.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';
import { Route, Switch } from 'react-router-dom';
import './scss/PublicLayout.scss';
import './scss/style.scss';
import PublicFooter from './containers/PublicFooter';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));
const TheAdminLayout = React.lazy(() => import('./containers/TheAdminLayout'));

// Pages
const LandingPage = React.lazy(() => import('./views/pages/LandingPage/LandingPage'))
const StartPage = React.lazy(() => import('./views/pages/StartPage/StartPage'));
const ForgotPasswordPage = React.lazy(() => import('./views/pages/Auth/ForgotPasswordPage'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));
const Email = React.lazy(() => import('./views/pages/StartPage/EmailConfirmation/Email'));
const Confirm = React.lazy(() => import('./views/pages/StartPage/ConfirmPage/Confirm'))
const ChangePass = React.lazy(() => import('./views/pages/Forgotpassword/ChangePassword/ChangePass'))
const Checkout = React.lazy(() => import('./views/pages/CheckoutPage/Checkout'))
const Paymentvalidate = React.lazy(() => import('./views/pages/PaymentValidate/paymentvalidate'))
const MarketingPage = React.lazy(() => import('./views/pages/MarketingPage'))
const SuperAdminLogin = React.lazy(() => import('./views/SuperAdmin/Login/SuperAdminLogin'))

const PrivacyPolicy = React.lazy(() => import('./containers/PrivacyPolicy'))
const RefundPolicy = React.lazy(() => import('./containers/RefundPolicy'))
const TermsAndConditions = React.lazy(() => import('./containers/TermsAndCondition'))

const loginPath = ["/signin", "/signup", "/signup/?", "/free-invoice-system/:src/:refid/:campaign", "/free-gst-software/:src/:refid/:campaign", "/gst-software-in-tumkur/:src/:refid/:campaign", "/free-accounting-software/:src/:refid/:campaign", "/unlimited-invoice/:src/:refid/:campaign"]

const App = props => {
  return (
    <React.Fragment>
      <ToastContainer />
      <Route render={(props) => {
        const { location } = props;
        
        // Very defensive check for location and pathname
        if (!location || typeof location.pathname !== 'string') {
          return (
            <React.Suspense fallback={loading}>
              <div className="pt-5 text-center">
                <div className="sk-spinner sk-spinner-pulse"></div>
                <div className="mt-2">Initializing router...</div>
              </div>
            </React.Suspense>
          );
        }

        const isSuperAdmin = location.pathname.startsWith('/super-admin');
        const isDashboard = ['/dashboard', '/invoice', '/purchase', '/expense', '/report'].some(p => location.pathname.startsWith(p));
        const isPublic = !isSuperAdmin && !isDashboard;
        const isAuth = ['/signin', '/signup', '/forgot-password'].includes(location.pathname);

        const content = (
          <React.Suspense fallback={loading}>
            <Switch>
              <Route exact path='/' name="Landing Page" render={props => <LandingPage {...props} />} />
              <Route exact path={loginPath} name="Login Page" render={props => <StartPage {...props} />} />
              <Route exact path="/forgot-password" name="forgot-password" render={props => <ForgotPasswordPage {...props} />} />
              <Route exact path="/emailconfirmation/:email" name="Email" render={props => <Email {...props} />} />
              <Route exact path="/confirm/:token" name="Email" render={props => <Confirm {...props} />} />
              <Route exact path="/change-password/:token" name='change-password' render={props => <ChangePass {...props} />} />
              <Route exact path="/checkout/" name='Checkout' render={props => <Checkout {...props} />} />
              <Route exact path="/Paymentvalidate/" name='Paymentvalidate' render={props => <Paymentvalidate {...props} />} />
              <Route exact path="/privacy-policy" name='privacy-policy' render={props => <PrivacyPolicy {...props} />} />
              <Route exact path="/refund-policy" name='refund-policy' render={props => <RefundPolicy {...props} />} />
              <Route exact path="/terms-conditions" name='terms-conditions' render={props => <TermsAndConditions {...props} />} />
              <Route exact path="/404" name="Page 404" render={props => <Page404 {...props} />} />
              <Route exact path="/500" name="Page 500" render={props => <Page500 {...props} />} />
              <Route exact path="/super-admin/login" name="Super Admin Login" render={props => <SuperAdminLogin {...props} />} />
              <Route exact path="/marketing" name="Marketing Page" render={props => <MarketingPage {...props} />} />
              <Route path="/super-admin" name="Super Admin" render={props => <TheAdminLayout {...props} />} />
              <Route path="/" name="Home" render={props => <TheLayout {...props} />} />
            </Switch>
          </React.Suspense>
        );

        if (isPublic) {
          return (
            <div className="public-app-layout">
              <main className="public-app-main">
                {content}
              </main>
              <PublicFooter compact={isAuth} />
            </div>
          );
        }

        return content;
      }} />
    </React.Fragment>
  );
}
export default App;
